import { Component, ElementRef, Input, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { FormGroup, FormArray, FormBuilder, Validators } from "@angular/forms";
import { AuthService } from "src/app/core/services/auth.service";
import { LoginService } from "src/app/core/services/login.service";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { UrlConstants } from "src/app/_helpers/url-constants";
import { RoleSignupService } from "src/app/core/services/role-signup.service";
import { OtpVerifyService } from "src/app/core/services/otp-verify.service";
import { ToastNotificationService } from "src/app/core/services/toast-notification.service";
import { NgxSpinnerService } from "ngx-spinner";
import { TitleCasePipe } from "@angular/common";
import { CommonService } from "src/app/core/services/common.service";
import { SaleInvoiceService } from "src/app/core/services/sale-invoice.service";

@Component({
  selector: 'app-login-employee',
  templateUrl: './login-employee.component.html',
  styleUrls: ['./login-employee.component.scss']
})
export class LoginEmployeeComponent implements OnInit {

  @ViewChild('passwordInput', { static: false }) passwordInput: ElementRef<HTMLInputElement>;
  public visible: boolean = false;
  public changeType: boolean = true;
  public user: number;
  public CustLogintoggle: boolean;
  public hide: boolean = true;
  public userName: String = "Client";
  public isOtpField: boolean = false;
  public isVerifyOtp: boolean = false;
  public successful: boolean = false;
  public otpErrorMessage: boolean = false;
  public messageSuccess: boolean;
  public resend: any;
  public submitted: boolean;
  @Input() UserType: string;
  public isLoginBtn: boolean = false;
  UserDatacomplte: boolean = false;
  public clientForm: FormGroup = this.fb.group({
    username: ["", [Validators.required, Validators.email, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$")]],
    password: ["", [Validators.required]],
    rememberme: [true],
  });
  public custForm: FormGroup = this.fb.group({
    username: ["", [
      Validators.required,
      Validators.maxLength(10),
      Validators.minLength(10),

    ]
    ],
    //username : [Validators.minLength(10), Validators.maxLength(10), Validators.pattern("^[0-9]*$")],
    mobileOtp: [
      "",
      [
        Validators.required,
        Validators.maxLength(6),
        Validators.minLength(6),
        Validators.pattern("^[0-9]{6}"),
      ],
    ],
  });
  public otpClientData: FormGroup = this.fb.group({
    emailotp: ["", [Validators.required, Validators.pattern("[0-9]{10}")]],
  });

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private authService: AuthService,
    private loginService: LoginService,
    public otpVerify: OtpVerifyService,
    private http: HttpClient,
    public roleSignupService: RoleSignupService,
    private toastService: ToastNotificationService,
    private spinner: NgxSpinnerService,
    private titleCasePipe: TitleCasePipe,
    private route: ActivatedRoute,
    private saleInvoiceService: SaleInvoiceService,
    private commonService: CommonService,
  ) {
    const credentials = this.authService.retrieveRememberedCredentials();
    console.log("credential rericvedddd in employeee login", credentials)
    if (credentials) {
      if (credentials.userType == "CLIENT") {
        this.clientForm.patchValue({
          username: credentials.username,
          password: credentials.password,
          rememberMe: true

        })
      } else if (credentials.userType == "CUSTOMER") {
        this.custForm.patchValue({
          username: credentials.username,
          rememberMe: true

        })
      }else if (credentials.userType == "EMPLOYEE") {
        this.clientForm.patchValue({
          username: credentials.username,
          password: credentials.password,
          rememberMe: true
        })
      }
    }
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.CustLogintoggle = params['CustLogintoggle'] === 'true';
    });
    this.authService.logout();
  }

  get clientControls() {
    return this.clientForm.controls;
  }

  moveFocus(event: KeyboardEvent, nextInput: ElementRef<HTMLInputElement>): void {
    if (event.key === 'Enter') {
      event.preventDefault(); // Prevent form submission
      nextInput.nativeElement.focus();
    }
  }

  backToRoleSelecetion() {
    this.router.navigate(['auth/role-selection']);
  }

  // this click handler is called when the user is clicked on the register link
  onCustomerClick() {
    this.router.navigate(['/auth/register'], { queryParams: { Custtoggle: 'false' } });
  }

  onRetailerClick() {
    this.router.navigate(['/auth/register'], { queryParams: { Custtoggle: 'true' } });
  }

  //function for password masking
  toggleShow() {
    this.visible = !this.visible;
    this.changeType = !this.changeType;
  }
  show(id) {
    if (id === 3) {
      this.user = 3;
      this.CustLogintoggle = false;
      this.userName = "Client";
    } else if (id === 4) {
      this.user = 4;
      this.CustLogintoggle = true;
      this.userName = "Customer";
    }
  }
  hideshowVerifylogin() {
    this.isVerifyOtp = false;
    this.CustLogintoggle = false;
  }

  clientLogin() {
    this.submitted = true;
    if (this.clientForm.invalid) {
      this.toastService.toastMsg({
        title: "Error",
        content: "Fill All Required Fields.",
      });
      return false;
    }
    else {
      var sendUserType
      if(this.UserType == 'Retailer'){
        sendUserType = "CLIENT"
      }else if(this.UserType == 'Shop'){
        sendUserType = "SHOP"
      }else if(this.UserType == 'Warehouse'){
        sendUserType = "WAREHOUSE"
      }else if(this.UserType == 'Employee'){
        sendUserType = "EMPLOYEE"
      }else if(this.UserType == 'Customer'){
        sendUserType = "CUSTOMER"
      }else {
        this.toastService.toastMsg({
          title: "Error",
          content: "Usertype is not valid",
        });
      }

      let data = {
        email: this.clientForm.controls.username.value,
        password: this.clientForm.controls.password.value,
        rememberme: this.clientForm.controls.rememberme.value,
        userType : sendUserType
      };
      this.isLoginBtn = true;
      this.authService.login(data).subscribe(async (res) => {
        console.log("res login", res)
        this.isLoginBtn = false;
        this.spinner.hide();

        if (res.data) {
          await this.startSession();
          this.router.navigate(["/pages/sale-invoice"]);
          // this.router.navigate(["/pages/employee-work/Profile-employee"]);
          this.toastService.toastMsg({
            title: "Success",
            content: "Login Successfully!",
          });
        } else {
          this.router.navigate(["/pages/sale-invoice"]);
        }
      },
        (err) => {
          if (err.error.status === 406) {
            this.toastService.toastMsg({
              title: "Error",
              content: "User Not Verified. Please Check Your Register Email",
            });
            this.successful = true;
            this.isLoginBtn = false;
            let data = {
              email: this.clientForm.controls.username.value,
            };
          } else if (err.error.status == 404) {
            this.isLoginBtn = false;
            this.toastService.toastMsg({
              title: "Error",
              content: "User Not Found!!! Please Register Again!!!",
            });
          } else if (err.error.status == 404) {
            this.isLoginBtn = false;
            this.toastService.toastMsg({
              title: "Error",
              content: "Invalid Credentials.",
            });
          } else if (err.error.status == 401) {
            this.isLoginBtn = false;
            this.toastService.toastMsg({
              title: "Error",
              content: this.titleCasePipe.transform(err.error.error_message),
            });
          } else if (err.error.status == 400) {
            this.isLoginBtn = false;
            this.toastService.toastMsg({
              title: "Error",
              content: this.titleCasePipe.transform(err.error.error_message),
            });
          }
          else if (err.error.status == 403) {
            this.isLoginBtn = false;
            this.toastService.toastMsg({
              title: "Error",
              content: this.titleCasePipe.transform(err.error.error_message),
            });
          } else {
            this.isLoginBtn = false;
            this.toastService.toastMsg({
              title: "Error",
              content: "User Not Found Or Wrong Password.",
            });
          }
        }
      );
    }
  }


  /**
   * Customer OTP post method
   */
  sendOtp() {
    // this.spinner.show();
    let data = {
      mobile: this.custForm.controls.username.value,
    };
    this.isLoginBtn = true;
    this.http
      .post(environment.apiUrl + "users/sendCustomerOtp", data)
      .subscribe(
        (res) => {
          // this.spinner.hide();
          this.isLoginBtn = false;
          this.isOtpField = true;
        },
        (err) => {
          // this.spinner.hide();
          this.isLoginBtn = false;
          // this.toastService.openErrorSnackBar(
          //   "Number Not Registered Or Invalid Number"
          // );
          this.toastService.toastMsg({
            title: "Error",
            content: "Number Not Registered Or Invalid Number",
          });
        }
      );
  }

  /**
   * Customer Login and OTP verify
   */
  verifyOtp() {
    // this.spinner.show();
    this.isLoginBtn = true;
    let data = {
      mobile: this.custForm.controls.username.value,
      type: "1",
      mobileotp: this.custForm.controls.mobileOtp.value,
    };
    // this.http.post(environment.apiUrl + UrlConstants.verifyCustomerOtp, data)
    //   .subscribe(res => {
    //     if (res) {
    //       // this.spinner.hide();
    //       this.isLoginBtn = false;
    //       let data = {
    //         mobile: this.custForm.controls.username.value,
    //         mobileotp: this.custForm.controls.mobileOtp.value
    //       }
    this.authService.custLogin(data).subscribe((res) => {
      if (this.UserDatacomplte) {
        this.router.navigate(["pages/customer/customer-dashboard"]);
        this.toastService.toastMsg({
          title: "Success",
          content: "Login Successfully!",
        })
      } else {
        this.toastService.toastMsg({
          title: "Error",
          content: "Fill All Required Fields.",
        })
        this.router.navigate(["pages/customer/customer-profile-setting"]);
      }
    });
    //   }
    // }, (err) => {
    //   // this.spinner.hide();
    //   this.isLoginBtn = false;
    //   this.toastService.openErrorSnackBar("Invalid Otp")
    // })
  }

  /**
   * Client OTP veify
   */
  verifyClientOtp() {
    // this.spinner.show();
    this.isLoginBtn = true;
    const data = {
      email: this.clientForm.controls.username.value,
      emailotp: this.otpClientData.controls.emailotp.value,
    };
    this.otpVerify.verifyCLientOtp(data).then(
      () => {
        this.isLoginBtn = false;
        // this.spinner.hide();
        this.isVerifyOtp = false;
      },
      (err) => {
        this.isLoginBtn = false;
      }
    );
  }
  /**
   * Customer Resend OTP
   */
  customerLoginResendOtp() {
    // this.spinner.show();
    this.isLoginBtn = true;
    let d = {
      mobile: this.custForm.controls.username.value,
    };
    this.loginService.postSendOtp(d).then(
      (res) => {
        // this.spinner.hide();
        this.isLoginBtn = false;
        this.resend = res;
      },
      (err) => {
        this.isLoginBtn = false;
      }
    );
    this.messageSuccess = true;
    setTimeout(() => {
      //<<<---using ()=> syntax
      this.messageSuccess = false;
    }, 120000);
  }
  f() {
    console.log("this.custForm.controls", this.custForm.controls);
    return this.custForm.controls;
  }
  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

startSession(): Promise<any> {
    return new Promise((resolve, reject) => {
      let currentUser = JSON.parse(localStorage.getItem('currentUser'));
      const requestBody = {
        userId: currentUser.id,
        openingbalance: 0,
        closingbalance: null
      }
      this.commonService.startSession(requestBody).then(async (res: any) => {
        if (res.success) {
          if (currentUser) {
            currentUser.dailysessionId = res.data.sessionId;
          } else {
            currentUser = {
              ...currentUser,
              dailysessionId: res.data.sessionId
            };
          }
          // Save the updated currentUser object back to local storage
          localStorage.setItem('currentUser', JSON.stringify(currentUser));

          let totalamount = 0;
          const reponse: any = await this.saleInvoiceService.getDailyRegisterById({}, res.data.sessionId);
          if (reponse.success && reponse.data) {
            totalamount = reponse.data?.totalamount;
          }
          // Check if session already exists
          if (res.data.alreadyexists && totalamount > 0) {
            // Close the session and navigate to the close register page
            this.router.navigate(['/pages/close-register']);
            // Trigger the modal programmatically
            // const modalTrigger = document.getElementById('trigger-modal');
            // modalTrigger?.click();
            this.toastService.toastMsg({
              title: 'Warning',
              content: 'Session was not close yet. Please close the session first.',
            });
          } else {
            // Regular startup screen logic
            this.toastService.toastMsg({
              title: 'Success',
              content: 'Session started successfully!',
            });
            resolve("success")
          }
        }else if (res.status === 406 && res.error_message === 'session already running') {
          // Handle session already running case
          // const modalTrigger = document.getElementById('trigger-modal');
          // modalTrigger?.click();
          resolve("success")
        } else {
          // Handle other types of errors
          this.toastService.toastMsg({
            title: 'Error',
            content: res.error_message || 'An error occurred while starting the session.',
          });
      
        }
      }).catch((err) => {
        if (err.status === 406 && err.error.error_message.trim() === 'session already running') {
          // Handle session already running case
          // const modalTrigger = document.getElementById('trigger-modal');
          // modalTrigger?.click();  // Open the modal to notify the user
        } else {
          this.toastService.toastMsg({
            title: 'Error',
            content: err.error.error_message,
          });
          reject("failed")
          // content: 'An unexpected error occurred. Please try again later.',
        }
      });
    });
  }

  redirectToCloseRegister() {
    // Logic to redirect to the close register page
    this.router.navigate(['/pages/close-register']);
  }
}
